module.exports = __webpack_public_path__ + "img/44.845c4e1a.svg";